import React from "react";
import { ProductModel } from "../../ShowcasePanel/ShowcasePanelModel";

import "./BenefitItem.css";
import { renderRichText } from "@storyblok/react";
import Utils from "../../../core/Utils/Utils";

const BenefitItem: React.FC<{
  blok: ProductModel;
  benefitId: string;
  containerColor: string;
  fontFamily: string;
}> = ({ blok, benefitId, containerColor, fontFamily }) => {
  const entity = blok.benefits.find((x) => x.id === benefitId);
  if (!entity) {
    return null;
  }
  const bodyHTML = renderRichText(entity.benefits) || "";

  return (
    <div
      className="list-panel-item benefit-item"
      key={`list-panel-item-${blok._uid}-${benefitId}`}
      style={{ backgroundColor: containerColor }}
    >
      <img
        src={Utils.getCacheUrl(entity.image?.filename)}
        alt=""
        onError={(e) => Utils.handleImageError(e, entity.image.filename)}
      />
      <h3 className="item-title h3">{entity.title}</h3>
      <div className="item-description" style={{ fontFamily: fontFamily }}>
        <div dangerouslySetInnerHTML={{ __html: bodyHTML }}></div>
      </div>
    </div>
  );
};

export default BenefitItem;
